var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 2.66699H2.66732C1.93198 2.66699 1.33398 3.26499 1.33398 4.00033V12.0003C1.33398 12.7357 1.93198 13.3337 2.66732 13.3337H13.334C14.0693 13.3337 14.6673 12.7357 14.6673 12.0003V4.00033C14.6673 3.26499 14.0693 2.66699 13.334 2.66699ZM13.334 4.00033V4.34099L8.00065 8.48966L2.66732 4.34166V4.00033H13.334ZM2.66732 12.0003V6.02966L7.59132 9.85966C7.70806 9.95135 7.8522 10.0012 8.00065 10.0012C8.1491 10.0012 8.29325 9.95135 8.40998 9.85966L13.334 6.02966L13.3353 12.0003H2.66732Z",
    fill: "#767A7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.73c1312dcc3bc9b5a803363aa4308ecb.svg";
export { ForwardRef as ReactComponent };